<template>
    <div class="chemistry-symbols d-flex">
        <div v-for="(symobl, i) in symbols" :key="i" class="symbol-item">
            <v-btn depressed :color="i < 13 ? 'red darken-2' : (i < 23 ? 'primary' : 'primary darken-2')" dark block @click="$emit('type', symobl)">
                {{symobl}}
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    props: {},
    data(){
        return {
            symbols: ['₎', '₍', 'ₛ', 'ₐ', 'ₗ', '→', '←', '⇌', '∆', '℃', '⁺', '⁻', 'EN', '⁰', '¹', '²', '³', '⁴', '⁵', '⁶', '⁷', '⁸', '⁹', '₀', '₁', '₂', '₃', '₄', '₅', '₆', '₇', '₈', '₉'],
        }
    }
}
</script>

<style lang="scss">
.chemistry-symbols{
    display: flex;
    flex-wrap: wrap;
    .symbol-item{
        flex: 1 1 5%;
        padding: 5px;

        .v-btn{
            font-size: 1.15rem;
        }
    }
}
</style>
